import React, {useEffect, useRef} from "react";
import styles from "./index.module.scss";
import Icons from "../../../public/assets/svg/index";
import { useRouter } from "next/router";
import _get from "lodash/get";

function index(props) {
  console.log("message", props.message);

  let auth = "";
  if (typeof window !== "undefined") {
    if (JSON.parse(localStorage.getItem("auth")) != null) {
      auth = JSON.parse(localStorage.getItem("auth")).data;
    }
  }
//console.log("this is prop message", props.message);
  const router = useRouter();
  const closeIt = () => {
    props.setSuccessModal(false);
    document.body.style.overflow = "unset";
    if (props.setfail) {
      props.setFail(false);
    }
    if (props.parent == "createBot") {
      router.push("/botStore");
    }
    if (props.title == "Feedback") {
      router.push("/employeetwin");
    }
    if (props.setMessage) {
      props.setMessage("");
    }
    if (props.session) {
      props.sessionTimeOutCheck(false);
    }
    // if(props.setFail){
    //   props.setFail(false)
    // }
  };

  const handlePopup = () => {
    props.onCloseModal();
  };
  const handleRoiModal = () => {
    props.closeModal(); // Call the closeModal function from the parent
  };

  const modalRef = React.useRef(null)

  // method to close the modal if clicked outside
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        //console.log(ref.current,"lllllll");
        //console.log(event.target,"eeeeeee");
        if (ref.current && !ref.current.contains(event.target)) {
          if (props.roiFormModal == 'closeBtn') {
          } else {
            props.setSuccessModal(false);
          }
        }
      }
      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(modalRef);
  const userEmailName = auth.name.split(' ');
  const capitalizedWords = userEmailName.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  const capitalizedUsername = capitalizedWords.join(' ');
  // console.log('capitalizedUsername',capitalizedUsername);

  return (
    <div className={styles.successContainer}>
      <div className={styles.modalBox} ref = {modalRef}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>{props.title ? props.title : ""}</p>
        </div>
        <div className={styles.modalBody}>
          {props.fail ? (
            <div className={styles.fail}>
              <Icons name="failure" />
            </div>
          ) : (
            <div className={styles.status}>
              <Icons name="whitetick" />
            </div>
          )}

          <div className={`${styles.textBody} ml-3`}>
            {/* { !props.session ?  */}
            {/* <p className={styles.texthead}> */}
              {/* Hi <strong>{auth.name},</strong> */}
              {/* List Of Users */}
            {/* </p> : null } */}
            
            <div className={styles.textcontent}>
              {props.message
                ? (<>
                {props.roiFormModal == 'closeBtn' ? (<>
                  { !props.session ? 
                  <p className={styles.texthead}>
                    Hi <strong>{capitalizedUsername},</strong> Your Form Submitted Successfully.
                  </p> : null }
                </>):
                <div className={styles.usersWrapper}>
                  <ul className={styles.usersList}>
                    {props.message.map((name, index) => (
                      <li className={styles.userList} key={index}>{name}</li>
                    ))}
                  </ul>
                  </div>}
                </>)
                : " We have received your request for getting the bot and is shared with our team. We will reach you with your requirements."}
            </div>
          </div>
        </div>
        <div className={styles.modalFooter}>
          {props.areYouSure ? (
            <div className={styles.areYouSureBtn}>
              <span
                className={styles.exportListBtn}
                onClick={() => props.setSuccessModal(true)}
              >
                Yes
              </span>
              <span
                className={styles.exportListBtn}
                onClick={() => props.setSuccessModal(false)}
              >
                No
              </span>
            </div>
          ) : props.session ? (
            <div className={styles.combinedBtn}>
              <span className={styles.exportListBtn} onClick={() => closeIt()}>
                Ok
              </span>
            </div>
          ) : (
            (props.manageEmpTwin == 'removeCloseBtn')? (<div className={styles.SubmitAnIdeaBtn}><span className={styles.submitAnIdeaOk} onClick={handlePopup}>
                OK
              </span></div>) : (props.roiFormModal == 'closeBtn') ? (<div className={styles.SubmitAnIdeaBtn}><span className={styles.submitAnIdeaOk} onClick={handleRoiModal}>
                OK
              </span></div>) : (<div className={styles.combinedBtn}>
              <span className={styles.exportListBtn} onClick={() => closeIt()}>
                Close
              </span>
            </div>)
          )}
        </div>
      </div>
    </div>
  );
}

export default index;


